module.exports = __webpack_public_path__ + "media/happy_bday_recorder.128cd18a.mp3";